import { render, staticRenderFns } from "./hotManage.vue?vue&type=template&id=020bf960&scoped=true&"
import script from "./hotManage.vue?vue&type=script&lang=ts&"
export * from "./hotManage.vue?vue&type=script&lang=ts&"
import style0 from "./hotManage.vue?vue&type=style&index=0&id=020bf960&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "020bf960",
  null
  
)

export default component.exports